import ResizableContainer from "../core/ResizableContainer";
import ResizableScene from "../core/ResizableScene";

export default class LoadingContainer extends ResizableContainer {
    private _targetPercent = 0;
    private _percent = 0;
    private _timer = 0;

    private _loadBG: Phaser.GameObjects.Image;
    private _loadFill: Phaser.GameObjects.Image;

    //Is first load needed
    constructor(scene: ResizableScene) {
        super(scene, 0, 0);
        this._targetPercent = 0.001;
        this._percent = 0.001;

        const loadBG = this._loadBG = scene.add.image(0, 0, "loadingBarBacker");
        loadBG.setDisplaySize(scene.viewport.width, loadBG.height);
        loadBG.setSize(loadBG.displayWidth, loadBG.displayHeight);
        const loadFill = this._loadFill = scene.add.image(0, 0, "loadingBarFill");
        loadFill.setOrigin(0, 0.5);
        this.add([loadBG, loadFill]);
        this.setSize(loadBG.displayWidth, loadBG.displayHeight);

        this.onUpdate();
        this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
        this.once(Phaser.GameObjects.Events.DESTROY, this.shutdown, this);
    }

    update(_t: number, dt: number): void {
        dt /= 1000;
        this._percent -= (this._percent - this._targetPercent) * 8 * dt;
        this.onUpdate();
    }

    onUpdate(): void {
        if (this._timer < 10) {
            this._timer++;
        }
        this._loadBG.setDisplaySize(this.scene.viewport.width, this._loadBG.height);
        this._loadBG.setSize(this._loadBG.displayWidth, this._loadBG.displayHeight);
        this.setSize(this._loadBG.displayWidth, this._loadBG.displayHeight);
        this._loadFill.displayWidth = this._loadBG.displayWidth * this._percent;
        this._loadFill.setSize(this._loadFill.displayWidth, this._loadFill.displayHeight);
        this.scene.alignIn.BottomLeft(this._loadFill, this._loadBG, 0, 0);
    }

    setLoadPercent(percent: number): void {
        if (isNaN(percent)) percent = 0; // nothing to load = 0% progress
        if (this._timer < 10 && percent == 1) percent = 0; // prevent percent jumping straight to 1 for first frame
        this._targetPercent = Math.max(percent, this._targetPercent); //only forward!
        this.onUpdate();
    }

    setLoadComplete(): void {
        this._targetPercent = 1;
        this._percent = 1;
        this.onUpdate();
    }

    shutdown(): void {
        this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
        super.shutdown();
    }
}
